<template>
  <div>
    <!-- ================= FILTER CARD ================= -->
    <div class="card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing">
      <div class="row g-3 p-15 p-sm-20 p-md-25">
        <div class="col-md-3">
          <label class="form-label">Ville</label>
          <v-select
            class="filter-select"
            label="name"
            :options="CitiesList"
            v-model="city_filter"
          />
        </div>

        <div class="col-md-3">
          <label class="form-label">Type d'application</label>
          <select class="form-control" v-model="app_code">
            <option value="">(Tous)</option>
            <option value="1">Excel Sheet</option>
            <option value="2">Shopify</option>
          </select>
        </div>

        <!-- <div class="col-md-3">
            <label class="form-label">Date d'ajout</label>
          </div> -->

        <div class="col-md-3 d-flex align-items-end gap-2">
          <button class="btn btn-primary" @click="filter">Filtrer</button>
          <button class="btn btn-danger" @click="Removefilter">Annuler</button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <!-- ================= TABLE ================= -->
        <!-- Loader -->
        <div v-if="isLoader" class="text-center">
          <div class="spinner-border text-primary"></div>
        </div>

        <vue-good-table
          :columns="columns"
          :rows="rows"
          responsive
          :select-options="{
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Colis Sélectionnés',
          }"
          @selected-rows-change="selectionChanged"
        >
          <template #emptystate>
            <div class="text-center text-muted">
              Aucune entrée correspondante trouvée
            </div>
          </template>

          <template #table-row="props">
            <span v-if="props.column.field === 'created_at'">
              {{ getDate(props.row.created_at) }}
            </span>

            <template v-else-if="props.column.field === 'from_sheet'">
            <h6 class="text-info" v-if="props.row.from_sheet == 1">
              <img
                v-if="props.row.from_sheet == 1"
                :src="require('@/assets/images/sheet.png')"
                style="width: 65px"
              />
              
            </h6>
            <h6 class="text-success" v-else-if="props.row.from_sheet == 2">
              <i class="flaticon-bag" > shopify</i>
            </h6>
          </template>

            <span v-else-if="props.column.field === 'status'">
              <span
                class="badge"
                :style="{ background: props.row.statut?.color || '#ff9f43' }"
              >
                {{ props.row.statut?.name || "Attente de confirmation" }}
              </span>
            </span>

            <span v-else-if="props.column.field === 'action'">
              <button
                class="btn btn-info btn-sm me-1"
                @click="showDetails(props.row)"
              >
                <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
              </button>
              <!-- <button
                class="btn btn-warning btn-sm me-1"
                @click="showUpdate(props.row)"
              >
                <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
              </button> -->
              <button
                class="btn btn-danger btn-sm"
                @click="Destroy_Coli(props.row.id)"
              >
                <i
                  class="flaticon-delete lh-1 me-8 position-relative top-1"
                ></i>
              </button>
            </span>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>

        <div class="mt-3 d-flex justify-content-end">
          <button class="btn btn-success" @click="ChangeColis">
            Confirmer les colis
          </button>
        </div>
      </div>
    </div>

    <!-- ================= DETAILS MODAL ================= -->
    <div class="modal fade" id="modalDetails" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Information du colis</h5>
            <button class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            <p><b>Code :</b> {{ ColiDetails.code }}</p>
            <p><b>Destinataire :</b> {{ ColiDetails.receiver }}</p>
            <p><b>Téléphone :</b> {{ ColiDetails.phone }}</p>
            <p><b>Ville :</b> {{ ColiDetails.city_name }}</p>
            <p><b>Adresse :</b> {{ ColiDetails.address }}</p>
            <p><b>Crbt :</b> {{ ColiDetails.price }} DH</p>
            <p><b>Commentaire :</b> {{ ColiDetails.note }}</p>
            <p><b v-if="ColiDetails.replace ==1">Colis Change </b>
            <b v-else-if="ColiDetails.partial ==1">Colis Partial </b>
            <b v-else>Colis Simple </b></p>

            
          </div>
        </div>
      </div>
    </div>

    <!-- EDIT MODAL -->
    <div class="modal fade" id="modalEdit" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <!-- HEADER -->
          <div class="modal-header">
            <h5 class="modal-title">Modifier une commande</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <!-- BODY -->
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12 col-md-4 mb-3">
                <div class="form-group">
                  <label for="can_open">Colis</label>
                  <select
                    class="form-control"
                    id="can_open"
                    v-model="colisData.can_open"
                  >
                    <option value="1">Ouvrir le colis</option>
                    <option value="0">Ne pas ouvrir le colis</option>
                  </select>
                </div>
              </div>
              <!-- <div class="col-12 col-md-4 mb-3">
                <div class="form-group">
                  <label for="fragile">Fragile</label>
                  <select
                    class="form-control"
                    id="fragile"
                    v-model="colisData.fragile"
                  >
                    <option value="1">Oui</option>
                    <option value="0">Non</option>
                  </select>
                </div>
              </div> -->
              <div class="col-12 col-md-4 mb-3">
                <div class="form-group">
                  <label for="replace">Colis Change</label>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="replace"
                      v-model="colisData.replace"
                      value="1"
                    />
                    <label class="form-check-label" for="replace">
                      <span>Colis Change</span>
                      <span style="font-size: 12px">
                        <br />( Le colis sera remplacer avec l'ancien a la
                        livraison. )
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <hr />
              </div>
              <!-- Code -->
              <div class="col-md-4">
                <label class="form-label">Code de suivi</label>
                <input
                  class="form-control"
                  v-model="colisData.code"
                  placeholder="Code de suivi"
                />
              </div>

              <!-- Destinataire -->
              <div class="col-md-4">
                <label class="form-label">Destinataire</label>
                <input
                  class="form-control"
                  v-model="colisData.receiver"
                  placeholder="Destinataire"
                />
              </div>

              <!-- Téléphone -->
              <div class="col-md-4">
                <label class="form-label">Numéro de téléphone *</label>
                <input
                  class="form-control"
                  type="number"
                  v-model="colisData.phone"
                  required
                  pattern="^([0][0-9]{9})$"
                  @keypress="
                    if (isNaN(Number($event.key))) $event.preventDefault();
                  "
                  placeholder="Numéro de téléphone"
                />
              </div>

              <!-- Ville -->
              <div class="col-md-4">
                <label class="form-label">Ville</label>
                <v-select
                  class="custom-select-height"
                  label="name"
                  :options="CitiesList"
                  v-model="cityColis"
                  placeholder="Ville"
                >
                  <template #no-options>
                    Taper un mot pour chercher la ville
                  </template>
                </v-select>
              </div>

              <!-- Adresse -->
              <div class="col-md-4">
                <label class="form-label">Adresse</label>
                <textarea
                  class="form-control"
                  rows="2"
                  v-model="colisData.address"
                  placeholder="Adresse"
                ></textarea>
              </div>

              <!-- Commentaire -->
              <div class="col-md-4">
                <label class="form-label">Commentaire</label>
                <textarea
                  class="form-control"
                  rows="2"
                  v-model="colisData.note"
                  placeholder="Commentaire"
                ></textarea>
              </div>

              <!-- Prix -->
              <div class="col-md-6">
                <label class="form-label">Prix</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  v-model="colisData.price"
                  placeholder="Prix"
                />
              </div>

              <!-- Nature produit -->
              <div class="col-md-6">
                <label class="form-label">Nature du produit</label>
                <input
                  class="form-control"
                  v-model="colisData.product_nature"
                  placeholder="Nature du produit"
                />
              </div>
            </div>
          </div>

          <!-- FOOTER -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Annuler
            </button>

            <button type="button" class="btn btn-primary" @click="EditColis">
              Enregistrer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import moment from "moment";
import { Modal } from "bootstrap";
import vSelect from "vue-select";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";

/* ================= STATE ================= */
const CitiesList = ref([]);
const rows = ref([]);
const isLoader = ref(false);
const city_filter = ref({});
const app_code = ref("");
const SelectedRows = ref([]);
const ColiDetails = ref({});

/* ================= TABLE ================= */
const columns = [
  { label: "Source", field: "from_sheet" },
  { label: "Code", field: "code" },
  { label: "Destinataire", field: "receiver" },
  { label: "Status", field: "status" },
  { label: "Date", field: "created_at" },
  { label: "Ville", field: "city_name" },
  { label: "Prix", field: "price" },
  { label: "Action", field: "action" },
];

const {showToast} = useAppToast();
const auth = useAuthStore();
const user = auth.user;
/* ================= METHODS ================= */
const getDate = (v) => moment(v).format("YYYY-MM-DD HH:mm");

const users = reactive({
  searchTerm: "",
  searchCity: "",
  searchApp: "",
  searchSDate: "",
  searchEDate: "",
  total: 0,
  per_page: 10,
  from: 1,
  to: 0,
  current_page: 1,
});

const getRecords = async (page = 1) => {
  isLoader.value = true;
  users.current_page = page; // ✅ update the current page
  try {
    const res = await api.get(
      `/api/auth/client/colis_confirmed?searchTerm=${users.searchTerm}&searchCity=${users.searchCity}&searchApp=${users.searchApp}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}&page=${users.current_page}&per_page=${users.per_page}`
    );
    rows.value = res.data.users.data;
    Object.assign(users, res.data.users);
  } catch (error) {
    showToast("Erreur lors du chargement", "error");
  } finally {
    isLoader.value = false;
  }
};

const filter = () => {
    users.searchCity = city_filter.value?.id || "";
    users.searchApp = app_code.value || "";
    getRecords();
}
const Removefilter = () => {
    city_filter.value = {};
    app_code.value = "";
    users.searchCity = "";
    users.searchApp = "";
    getRecords();
}

const selectionChanged = (p) => {
  SelectedRows.value = p.selectedRows;
};

const showDetails = (row) => {
  ColiDetails.value = row;
  new Modal(document.getElementById("modalDetails")).show();
};

const colisData = ref({});
const cityColis = ref(null);

const showUpdate = (row) => {
  // clone row to avoid mutating table directly
  colisData.value = { ...row };

  // optional: sync city select
  cityColis.value = row.city ? { id: row.city_id, name: row.city } : null;

  const modal = new Modal(document.getElementById("modalEdit"));
  modal.show();
};

const EditColis = async () => {
  const data = new FormData();
  data.append("code", colisData.value.code);
  data.append("receiver", colisData.value.receiver);
  data.append("phone", colisData.value.phone);
  data.append("address", colisData.value.address);
  data.append("note", colisData.value.note);
  data.append("price", colisData.value.price);
  data.append("product_nature", colisData.value.product_nature);
  data.append("city_id", cityColis.value?.id ?? "");
  data.append("city_name", cityColis.value?.name ?? "");
  data.append("fragile", colisData.value.fragile || 0);
  data.append("can_open", colisData.value.can_open || 1);
  data.append("replace", colisData.value.replace || 0);

  await api.post(`/api/auth/client/editNewSheet/${colisData.value.id}`, data);

  // close modal
  Modal.getInstance(document.getElementById("modalEdit")).hide();

  // refresh table
  getRecords();
};

const Destroy_Coli = (id) => {
  Swal.fire({
    text: "Vous voulez supprimer ce colis ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimer!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      api.post(`/api/auth/client/DeleteColis/${id}`).then(() => getRecords());
    }
  });
};

const ChangeColis = () => {
  if (!SelectedRows.value.length) {
    showToast("Merci de sélectionner des colis", "error");
    return;
  }
  api
    .post(`/api/auth/client/addConfirmedParcel`, {
      colis: SelectedRows.value,
    })
    .then(() => getRecords());
};

/* ================= INIT ================= */
onMounted(async () => {
  CitiesList.value = (await api.get(`/api/auth/citiesList`)).data;
  getRecords();
});
</script>

<style scoped>
.badge {
  color: #fff;
  padding: 5px 8px;
}
</style>
